import classNames from 'classnames';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import type { OldToNewValueProps } from './OldToNewValue';
import { OldToNewValue } from './OldToNewValue';

export type OldToNewReasonProps = {
  oldValue: boolean;
  newValue: boolean;
  reason?: string;
  reasonDescription?: string | null;
} & Omit<OldToNewValueProps, 'type' | 'oldValue' | 'newValue'>;

export function OldToNewReason({ reason, oldValue, newValue, reasonDescription }: OldToNewReasonProps) {
  const oldValueDisplay = oldValue ? 'ON' : 'OFF';
  const isValueDiff = oldValue !== newValue;
  const newValueDisplay = newValue ? 'ON' : 'OFF';

  return (
    <div
      className={classNames({ 'pt-2': reason })}
      {...getDataAutoTestAttributes(['old-to-new-event']).attributes}
    >
      {isValueDiff ? (
        <OldToNewValue
          type="text"
          oldValue={oldValueDisplay}
          newValue={newValueDisplay}
        />
      ) : (
        <span className="text-xs text-slate-900">{oldValueDisplay}</span>
      )}
      {reason && (
        <div className="mt-2 border-t border-slate-100 py-2 text-xs">
          <span className="mr-[6px] font-semibold">Not billable reason:</span>
          {reasonDescription ? `${reason}.` : reason}
          {reasonDescription && <span className="block">{reasonDescription}</span>}
        </div>
      )}
    </div>
  );
}
